export const cafeInfo = {
  name: "Cafe Courtyard",
  tagline: "Where Continental Food Becomes Conversation",
  description:
    "A digital destination for continental food, culture, stories, and conversations. The café acts as the host of a growing community where people explore continental cuisine, food stories, chef insights, cultural discussions, and meaningful conversations.",
  address: {
    line1: "71, Street Number 254",
    line2: "CD Block (Newtown), Action Area I",
    city: "New Town",
    state: "West Bengal",
    pincode: "700156",
    country: "India",
  },
  contact: {
    phone: "+91 8981937111",
    email: "cafecourtyard21@gmail.com",
  },
  hours: {
    weekdays: "9:00 AM — 9:00 PM",
    weekends: "8:00 AM — 10:00 PM",
    note: "Sunday Brunch starts at 9:00 AM",
  },
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100064855122061",
    instagram: "https://www.instagram.com/cafecourtyard.sd",
    linkedin: "https://www.linkedin.com/in/sudarshana-dutt-833b1934/",
  },
  founder: {
    name: "Sudarshana Dutt",
    title: "Founder & Curator",
    bio: "Sudarshana Dutt founded Cafe Courtyard with a vision to create more than a café — a living journal of continental food culture in the heart of Kolkata. Her journey from corporate life to culinary curation is a story of passion, patience, and the belief that every meal should tell a story.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_34c1beab36c510cc1c6a4880021d3842_2d5fc02b.jpg",
  },
  philosophy: [
    {
      title: "Stories First",
      description: "Every dish has an origin, a journey, a reason for being.",
    },
    {
      title: "Community Always",
      description: "The table belongs to everyone who gathers around it.",
    },
    {
      title: "Quality Forever",
      description: "From farm to plate, no shortcuts, no compromises.",
    },
    {
      title: "Conversation Matters",
      description: "Good food deserves good company and good dialogue.",
    },
    {
      title: "Continental Soul",
      description: "Rooted in European tradition, reimagined for Kolkata.",
    },
  ],
};